import { render, staticRenderFns } from "./ModuleSelectorTwo.vue?vue&type=template&id=2b02bddc&scoped=true"
import script from "./ModuleSelectorTwo.vue?vue&type=script&lang=js"
export * from "./ModuleSelectorTwo.vue?vue&type=script&lang=js"
import style0 from "./ModuleSelectorTwo.vue?vue&type=style&index=0&id=2b02bddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b02bddc",
  null
  
)

export default component.exports